// @flow
import React from 'react';
import Card from 'material-ui/Card';
import styled from 'styled-components';
import moment from 'moment';
import { translate } from 'react-i18next';

import { ISO_DATE } from 'common/domain/DateRange';
import { Numeric } from 'common/components/Number';

const ContentWrapper = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-end;
`;

const Date = styled.span`
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  opacity: 0.5;
  color: black;
`;

const Reach = styled(Numeric)`
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  color: ${({ theme }) => theme.colors.reach};
  margin-top: ${({ theme }) => theme.metrics.tinyMargin}px;
`;

const ListeningTime = styled(Numeric)`
  font-size: ${({ theme }) => theme.fonts.style.sub.fontSize}px;
  font-weight: ${({ theme }) => theme.fonts.weights.bold};
  color: ${({ theme }) => theme.colors.listeningTime};
  margin-left: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const InterpolatedMessage = styled.div`
  padding: ${({ theme }) => theme.metrics.smallMargin}px;

  color: ${({ theme }) => theme.colors.message.important.color};
  font-size: ${({ theme }) => theme.fonts.style.small.fontSize}px;
  font-style: italic;
`;

export const INTERPOLATED_MESSAGE_ID = 'history-graph-tooltip-interpolated-message';

type Props = {
  payload: any;
  type: string;
  label: string;

  t: any;
}

export function HistoryGraphTooltip({ payload, t }: Props) {
  if (payload.length < 1) {
    return null;
  }

  const from = moment(payload[0].payload.from, ISO_DATE);
  const to = moment(payload[0].payload.to, ISO_DATE);

  const fromText = t('date.dayMonthShort', { value: from });
  const toText = t('date.dayMonthShort', { value: to });

  const { reach, listeningTime, interpolated } = payload[0].payload.tooltip;
  if (reach === 0 || listeningTime === 0) {
    return null;
  }

  return (
    <Card>
      <ContentWrapper>
        <Column>
          <Date>{`${fromText} ${t('to')} ${toText}`}</Date>
          <Reach value={reach} roundAt={0} />
        </Column>
        <Column>
          <Row>
            <ListeningTime value={listeningTime} roundAt={0} suffix={t('time.hours').toLowerCase()} />
          </Row>
        </Column>
      </ContentWrapper>
      {interpolated && <InterpolatedMessage id={INTERPOLATED_MESSAGE_ID}>{t('interpolated')}</InterpolatedMessage>}
    </Card>
  );
}

export default translate('history')(HistoryGraphTooltip);



// WEBPACK FOOTER //
// ./src/statsradio/modules/history/components/HistoryGraphTooltip.js